module.exports = __webpack_public_path__ + "static/media/img5.815130e9.jpg";